<template>
  <form-po
    ref="Form"
    :data="data"
    :dataID="data.id"
    :model="getModel"
    @onClosePO="$emit('onClosePO')"
    @updateModelItem="handlerUpdateModelItem"
    @change="$emit('change', $event)"
  />
</template>

<script>
import FormWrapperAutoSave from '@/components/Form/FormWrapperAutoSave'
export default {
  name: 'SectionSupplier',
  mixins: [FormWrapperAutoSave],
  components: {
    'form-po': () => import(/* webpackChunkName: 'SupplierPoRFQ2' */ './FormPO.vue')
  },
  props: {
    data: { type: Object }
  },
  created () {
    this.$bus.$onPromise('validate-all-sections', this.validate)
  },
  beforeDestroy () {
    this.$bus.$offPromise('validate-all-sections', this.validate)
  },
  computed: {
    isAvailableToSave () {
      return true
    }
  },
  methods: {
    getModel () {
      return {
        id: null,
        supplierCompanyID: null,
        supplierCompanyDetailID: null,
        supplierCompanyContactID: null,
        supplierInvoiceNumber: '',
        vatID: null,
        countryOriginID: null,
        poStillOpen: false,
        paymentDate: null,
        paidInFull: false,
        approvedForPaymentByEmployeeID: null,
        paymentRemarks: ''
      }
    },
    handleClosePO () {
      return this.validate()
        .catch((e) => {
          throw new Error(this.L10n('supplier-error'))
        })
    },
    validate () {
      return this.$refs.Form.validate()
    }
  }
}
</script>
